import { Terms } from '../context/auth/authContext/AuthContext.types'

import { getApiDomainFromHostname, reassignUrlDomain } from '@percent/utility'

export const environment = process.env.NX_PUBLIC_REACT_APP_ENV

export type Config = {
  urls: {
    appUrl: string
    baseUrl: string
    donationLinkBaseUrl: string
    helpCenterUrl: string
    hubspotWidgetKey: string
    howItWorksUrl: string
    privacyPolicyUrl: string
    termsOfUseUrl: string
  }
  terms: Record<Terms, string>
  keys: {
    publicKey?: string
    geolocation?: string
    hubspotWidgetKey?: string
    googleClientId?: string
    azureClientId?: string
    azureTenantId?: string
    recaptchaSiteKey?: string
  }
  ids: {
    donationLinkRef: string
  }
  allowedMessageOrigins: string[]
  counterTimeoutInSec?: string
  fundraiserId?: string
  acceptedBannerImgFormats: string
  acceptedBannerImgFormatsHuman: string
  maxParticipantSpots: number
  acceptedReceiptFormats: string
  acceptedReceiptFormatsHuman: string
}
const appDomain = getApiDomainFromHostname()
const DEFAULT_TEST_API_URL = 'https://localhost:8080/'
const DEFAULT_TEST_APP_URL = 'https://localhost:3000'
const DEFAULT_TEST_HUBSPOT_WIDGET_KEY = '123456789'
const { NX_PUBLIC_ALLOWED_MESSAGE_ORIGINS, NX_PUBLIC_API_URL, NX_PUBLIC_TEST_MODE, NX_PUBLIC_APP_URL } = process.env

export const config: Config = {
  urls: {
    appUrl:
      NX_PUBLIC_TEST_MODE === 'true'
        ? `${DEFAULT_TEST_APP_URL}`
        : `${reassignUrlDomain(NX_PUBLIC_APP_URL!, appDomain)}`,
    baseUrl:
      NX_PUBLIC_TEST_MODE === 'true'
        ? `${DEFAULT_TEST_API_URL}`
        : `${reassignUrlDomain(NX_PUBLIC_API_URL!, appDomain)}/`,
    hubspotWidgetKey:
      NX_PUBLIC_TEST_MODE === 'true'
        ? `${DEFAULT_TEST_HUBSPOT_WIDGET_KEY}`
        : `${process.env.NX_PUBLIC_REACT_APP_HUBSPOT_WIDGET_KEY}`,
    donationLinkBaseUrl: reassignUrlDomain(`${process.env.NX_PUBLIC_REACT_APP_DONATION_LINK_BASE_URL}`, appDomain),
    helpCenterUrl: 'https://employee-giving-help.goodstack.io/',
    howItWorksUrl: 'https://goodstack.io/employee-giving',
    privacyPolicyUrl: 'https://goodstack.io/legal/privacy-policy',
    termsOfUseUrl: 'https://goodstack.io/legal/employee-donation-additional-terms'
  },
  terms: {
    'percent:privacy:2024-01-01': 'https://goodstack.io/legal/privacy-policy',
    'workplace:terms:2024-01-01': 'https://goodstack.io/legal/employee-donation-additional-terms',
    'percent:privacy:2025-12-15': 'https://goodstack.io/legal/privacy-policy',
    'workplace:terms:2025-12-15': 'https://goodstack.io/legal/employee-donation-additional-terms'
  },
  keys: {
    publicKey: process.env.NX_PUBLIC_REACT_APP_PARTNER_PUBLIC_KEY,
    geolocation: process.env.NX_REACT_APP_GEOLOCATION_API_KEY,
    hubspotWidgetKey: process.env.NX_PUBLIC_REACT_APP_HUBSPOT_WIDGET_KEY,
    googleClientId: process.env.NX_PUBLIC_REACT_APP_GOOGLE_CLIENT_ID,
    azureClientId: process.env.NX_PUBLIC_REACT_APP_AZURE_CLIENT_ID,
    azureTenantId: process.env.NX_PUBLIC_REACT_APP_AZURE_TENANT_ID,
    recaptchaSiteKey: process.env.NX_PUBLIC_RECAPTCHA_SITE_KEY
  },
  ids: {
    donationLinkRef: process.env.NX_PUBLIC_REACT_APP_DONATION_LINK_REFERENCE!
  },
  counterTimeoutInSec: process.env.NX_PUBLIC_REACT_APP_WPG_COUNTER_TIMEOUT_IN_SEC,
  allowedMessageOrigins: NX_PUBLIC_ALLOWED_MESSAGE_ORIGINS ? JSON.parse(NX_PUBLIC_ALLOWED_MESSAGE_ORIGINS) : ['*'],
  fundraiserId: process.env.NX_PUBLIC_REACT_APP_FUNDRAISER_ID,
  acceptedBannerImgFormats: '.jpg,.jpeg,.png',
  acceptedBannerImgFormatsHuman: '.jpg, .jpeg, .png',
  acceptedReceiptFormats: '.jpg,.jpeg,.png,.pdf',
  acceptedReceiptFormatsHuman: '.jpg, .jpeg, .png, .pdf',
  maxParticipantSpots: 100000
}
